export default "/assets/images/mila-room-showcase-02.6e1495415c31b7ea.jpg";